<template>
  <div class="inquery_comments">

    <div class="inquery_main_comments">
      <div class="author_head_wrap">
        <div class="left">
          <div class="author">
            <i class="fas fa-user-tie "></i>
          </div>
          <div class="content_details">
            <p><b>{{ ticket.customer_name }}</b> </p>
            <p>{{ ticket.created_at }}</p>
          </div>
        </div>
        <div class="right">
          <button
              v-if="ticket.status === 'resolved' || ticket.status === 'closed'"
              type="button"
              class="btn btn-sm btn-outline-primary d_flex_center"
              disabled
          >
            <span>{{ ticket.status }}</span>
          </button>
          <button
              v-else
              type="button" class="btn btn-sm btn-outline-primary d_flex_center"
              @click="openReplyModal"
          >
            <span class="mr_5 d_flex_center">
                <svg fill="#000000" width="18px" height="18px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M10.53 5.03a.75.75 0 10-1.06-1.06l-6.25 6.25a.75.75 0 000 1.06l6.25 6.25a.75.75 0 101.06-1.06L5.56 11.5H17a3.248 3.248 0 013.25 3.248v4.502a.75.75 0 001.5 0v-4.502A4.748 4.748 0 0017 10H5.56l4.97-4.97z"></path></g></svg>
            </span>
            <span>Reply</span>
          </button>
        </div>
      </div>

      <div class="author_comment_text">
        <div v-html="ticket.description"></div>
        <attachment-preview-component
            v-if="ticket?.parent_mail?.attachments"
            :attachments="ticket.parent_mail.attachments"
        />
      </div>
    </div>
    <template v-for="(email, emailIndex) in ticket.emails" :key="'singleMail_'+emailIndex">
    <div v-if="email.email_creator_user_type !== 'admin'" class="inquery_main_comments ml_20">
      <div class="author_head_wrap">
        <div class="left">
          <div class="author">
            <i class="fas fa-user-tie "></i>
          </div>
          <div class="content_details">
            <p><b>{{ email?.email_created_by_customer?.name }}</b> </p>
            <p>{{ email.created_at_formatted }}</p>
          </div>
        </div>
        <div class="right">

          <button
              v-if="ticket.status === 'resolved' || ticket.status === 'closed'"
              type="button"
              class="btn btn-sm btn-outline-primary d_flex_center"
              disabled
          >
            <span>{{ ticket.status }}</span>
          </button>
          <button
              v-else
              type="button"
              class="btn btn-sm btn-outline-primary d_flex_center"
              @click="openReplyModal"
          >
              <span class="mr_5 d_flex_center">
                  <svg fill="#000000" width="18px" height="18px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M10.53 5.03a.75.75 0 10-1.06-1.06l-6.25 6.25a.75.75 0 000 1.06l6.25 6.25a.75.75 0 101.06-1.06L5.56 11.5H17a3.248 3.248 0 013.25 3.248v4.502a.75.75 0 001.5 0v-4.502A4.748 4.748 0 0017 10H5.56l4.97-4.97z"></path></g></svg>
              </span>
            <span>Reply</span>
          </button>
        </div>
      </div>
      <div class="author_comment_text">
        <div v-html="email.description"></div>
        <attachment-preview-component
            v-if="email?.attachments"
            :attachments="email.attachments"
        />
      </div>
    </div>

    <div v-if="email.email_creator_user_type === 'admin'" class="inquery_main_comments admin_reply ml_20">
      <div class="author_head_wrap">
        <div class="left">
          <div class="author">
            <i class="fas fa-user-secret"></i>
          </div>
          <div class="content_details">
            <p><b>{{ email?.email_created_by_user?.name }}</b> </p>
            <p>{{ email.created_at_formatted }}</p>
          </div>
        </div>
      </div>
      <div class="author_comment_text">
        <div v-html="email.description"></div>
        <attachment-preview-component
            v-if="email?.attachments"
            :attachments="email.attachments"
        />
      </div>
    </div>
    </template>

    <BaseModal
        v-if="isOpenReplyModal"
        title="Inquiry Reply"
        :closeModal="closeReplyModal"
        size="modal_850p"
    >
      <InquiryDetailsReply
          :closeModal="closeReplyModal"
          :loadData="getInquiryDetails"
          :inquiryId="inquiryId"
      />
    </BaseModal>

  </div>
</template>

<script>
import AttachmentPreviewComponent from "@/views/inquiry/AttachmentPreviewComponent.vue";
import InquiryDetailsReply from "@/views/inquiry/InquiryDetailsReply.vue";
import BaseModal from "@/components/BaseModal.vue";
export default {
  name: "DetailsInquiry",
  components: {BaseModal, AttachmentPreviewComponent, InquiryDetailsReply},
  props: ['inquiryId'],
  data() {
    return {
      ticket: {},
      isOpenReplyModal: false
    }
  },
  mounted() {
    this.getInquiryDetails()
  },
  methods: {
    getInquiryDetails(){
      this.axios.get(`/my-inquiry/${this.inquiryId}`).then(({ data }) => {
        this.ticket = data.data.data
      })
    },
    openReplyModal(){
      this.isOpenReplyModal = true
    },
    closeReplyModal(){
      this.isOpenReplyModal = false
      this.getInquiryDetails()
    }
  }
}
</script>

<style scoped>

</style>